module.exports = __webpack_public_path__ + "img/42.12e16442.png";